import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Wrap } from "../../../components/Layout/Page";
import { SecondaryNav } from "../../../components/AppChrome/components/SecondaryNav";
import { ReportGeneratorForm, ReportJobStatusPanel } from "../../../components";
import { generateReport } from "../../../redux/modules/reportGenerator";
import Loading from "../../../components/Loading";
import { SecondaryLinks } from "../../../utils/routes/reports";

@connect(
  (state) => ({
    appSetupComplete: state.appSetup.appSetupComplete,
    isFormDisabled: state.reportGenerator.isFormDisabled,
    showJobStatusPanel: state.reportGenerator.showJobStatusPanel,
    currentJobStatus: state.reportGenerator.currentJobStatus,
  }),
  {
    generateReport,
  }
)
class ReportGeneratorScene extends Component {
  static propTypes = {
    generateReport: PropTypes.func.isRequired,
    isFormDisabled: PropTypes.bool.isRequired,
    showJobStatusPanel: PropTypes.bool.isRequired,
    currentJobStatus: PropTypes.object.isRequired,
  };

  render() {
    const {
      isFormDisabled,
      showJobStatusPanel,
      currentJobStatus,
      appSetupComplete,
    } = this.props;

    // Ensure that we don't attempt to render the report generator
    // until user projects/sites have all finished being loaded
    if (!appSetupComplete)
      return (
        <Wrap>
          <Loading />
        </Wrap>
      );

    return (
      <Fragment>
        <Helmet title="Report Generator" />
        <SecondaryNav links={SecondaryLinks} />

        <Wrap>
          <ReportGeneratorForm
            onFormSubmit={(reportId, reportOptions) =>
              this.props.generateReport(reportId, reportOptions)
            }
            isFormDisabled={isFormDisabled}
          >
            {showJobStatusPanel ? (
              <ReportJobStatusPanel
                key={currentJobStatus.id}
                jobId={currentJobStatus.id}
                jobStart={currentJobStatus.start}
                jobMsg={currentJobStatus.msg}
                jobState={currentJobStatus.state}
                jobProgress={currentJobStatus.progress}
              />
            ) : null}
          </ReportGeneratorForm>
        </Wrap>
      </Fragment>
    );
  }
}

export default ReportGeneratorScene;
